import styled from 'styled-components'
import {media} from '../../theme/config'

export const SearchBarFlyout = styled.div`
  display: ${({show}) => (show ? 'block' : 'none')};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 15px 0 rgba(0,0,0,0.2);
  z-index: 2;
  
  &:before {
    background-color: ${({theme}) => theme.colors.greyscale.white};
    z-index: -1;
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    top: 4px;
    transform: translateY(-50%) rotate(45deg);
    box-shadow: -1px -1px 10px 0 rgba(0,0,0,.2);
    display: block;
    right: ${({showCart}) => (showCart ? '124px' : '73px')};
  }
`;

export const SearchBarWrapper = styled.div`
  margin-left: auto;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  padding: 12px 20px;
  z-index: 2;
  background: ${({theme}) => theme.colors.greyscale.white};
  
  @media ${media.mobileL} {
    padding: 0;
  }
`;

export const SearchBarInput = styled.input`
  width: 100%;
  min-width: 100%;
  height: 46px;
  min-height: 46px;
  padding: 13px 45px 13px 15px;
  appearance: none;
  border: 1px solid ${({theme}) => theme.colors.greyscale.base};
  border-radius: 3px;
  color: ${({theme}) => theme.colors.greyscale.black};
  background-color: ${({theme}) => theme.colors.greyscale.white};
  font-size: ${({theme}) => theme.typography.fontSize.fs4};

  @media ${media.mobileL} {
    font-size: ${({theme}) => theme.typography.fontSize.fs3};
  }
  
  &:focus,
  &:active {
    border: 2px solid ${({theme}) => theme.colors.greyscale.black}; 
  }
`;

export const SubmitButton = styled.button`
  position: absolute;
    height: 24px;
    padding: 0;
    top: 50%;
    right: 35px;
    transform: translateY(-50%);
    background: none;
    border: none;
  
  @media ${media.mobileL} {
    right: 15px;
  }
`
